import * as util from "../../../common/m_base/util"
import {override} from 'core-decorators'

import {RewardJsToggleCloseBtnShow, VideoBridgeToggleBouncesOff} from "@api";
import {getUrlParams} from "@src/common/util";

import {
    getEndScreenInfo,
} from "../../../api/index";
import Webview from "../../component/native/visible/Webview"
import Slot from "../../component/template/Slot";
import Container from "../../component/Container"
import {getFilePathByRemoteUrl} from '@src/common/util'
import MultipleOfferTemplate from "../../component/template/MultipleOfferTemplate";
import SingleVideoRewardManager from '../../component/visible/SingleVideoRewardManager/SingleVideoRewardManager'
import App from "../../App";
import CountdownButton from "../../component/visible/CountdownButton";
import {report} from "../../../common/decorators";
import {
    reportBizAddRewardToServer,
    reportBizAdTrackingClick,
    reportBizAdTrackingEndcardShow,
    reportBizAdTrackingImpression,
    reportBizAdTrackingVideoClose,
    reportBizAdTrackingVideoComplete,
    reportBizAdTrackingVideoFirstQuartile,
    reportBizAdTrackingVideoMidpoint,
    reportBizAdTrackingVideoMute,
    reportBizAdTrackingVideoPause,
    reportBizAdTrackingVideoPlayPercentage,
    reportBizAdTrackingVideoStart,
    reportBizAdTrackingVideoThirdQuartile,
    reportBizAdTrackingVideoUnmute,
    reportBizImpression,
    reportBizNoticeUrl,
} from "../../../common/m_common/mBizReport";
import {reportNonBizData} from "../../../common/m_common/mNonBizReport";
import Button from "../../component/visible/Button";
import {presetOnlyImpression, presetPvUrls} from "../../../common/m_common/mBizReportPreset";
import {
    presetBtPlayFirstClick,
    presetBtPlayFirstClose,
    presetBtPlayFirstDialogClick,
    presetBtPlayFirstDialogCloseAuto,
    presetBtPlayFirstDialogCloseManual,
    presetBtPlayFirstDialogShow,
    presetBtPlayFirstShow
} from "../../../common/m_common/mNonBizReportPreset";

/**
 * mintegral SDK 大模板
 */
export default class btChooseFirstDemo extends MultipleOfferTemplate {
    constructor(props = {}) {
        super(props)

        this.templateName = props.templateName || 'mtg_btChooseFirstDemo_template'

        this.currentOffer = this.campaignList[0]
    }

    show() {
        super.show()
        console.log('im show')
    }

    async adShowed(res) {
        super.adShowed(res);

        let adShowData = res && res.param;
        let userId = adShowData && adShowData.userId;
        let reward = adShowData && adShowData.reward;
        this.reward = adShowData && adShowData.reward;
        App.rewardInfo = {userId, reward}
        console.error('rewardInfo: ', App.rewardInfo, res)

        console.log('adShowCallback: RV IV 弹窗 & 关闭按钮逻辑初始化')
        // 开始 onlyImpression 上报
        console.log('// 开始 onlyImpression 上报')
        this.onlyImpressionTimingReport()
        // 预创建 show 之后其他阶段的测试 case
        console.log('// 预创建 show 之后其他阶段的测试 case')
        this.initOtherPhaseTestCase()
        console.log('// 预创建 show 之后其他阶段的测试 case done.')
        // RV IV 弹窗 & 关闭按钮逻辑初始化
        let {campaignList, appSetting, unitSetting} = window.initData
        let currentCampaign = campaignList[0]
        let ad_type = currentCampaign.ad_type

        // init test video
        let videoWrap = document.createElement('div')
        let videoLog = document.createElement('div')
        videoLog.id = 'videoLog'
        let videoElement = document.createElement('video')
        videoElement.src = 'https://cdn-adn-https-new.rayjump.com/cdn-adn/vh/19/10/29/10/58/40b237c9176f47cc00de81389090243d.mp4'
        videoElement.preload = 'auto'
        videoElement.setAttribute('playsinline', '')
        videoElement.setAttribute('webkit-playsinline', '')
        videoElement.style.cssText += `position: absolute;top: 50%;right: 50%;width: 20vw;height:20vw,object-fit: contain;z-index: 999; transform: translate3d(-50%, -50%, 0);`
        videoWrap.appendChild(videoElement)
        videoWrap.appendChild(videoLog)
        // document.querySelector('#app').appendChild(videoWrap)
        // videoElement.addEventListener('error', e => {
        //     console.error('播放视频时发生错误，终止播放，showfailed', e)
        //     // TODO: 走 showfailed 展示失败回调
        //     //  1. 回调开发者 showfailed
        //     //  2. 关闭当前广告
        // })
        // videoElement.addEventListener('timeupdate', e => {
        //     // TODO: 视频第一帧播放成功 impression
        //     //  1. 回调开发者 showfailed
        //     //  2. 关闭当前广告
        //     videoLog.insertAdjacentHTML("beforeend", `<div class="log-item">timeupdate：${videoElement.currentTime}</div>`)
        // })
        // videoElement.addEventListener('ended', e => {
        //     videoElement.style.cssText += 'width: 30vw;height:30vw,'
        //     console.log('================视频播放完成=================', videoElement, videoElement.currentTime, currentCampaign.video_length)
        // })
        // videoElement.addEventListener('click', () => {
        //     App.closeAd()
        // })
        // await videoElement.play().catch(e => {
        //     console.error('播放视频时出现问题', e, videoElement)
        // })

        // init SingleVideoRewardManager
        SingleVideoRewardManager.init({
            ad_type,
            appSetting,
            unitSetting,
            videoElement,
            currentCampaign,
            closeTplFunc() {
                App.closeAd()
            }
        })

        let countdown = new CountdownButton()
        countdown.appendTo(document.querySelector('#app'))
        countdown.show()
        let start = Date.now()
        setInterval(() => {
            countdown.countdown = Math.floor((Date.now() - start) / 1000)
        }, 1000)

    }

    initComponents() {
        super.initComponents()

        this.campaignList.forEach(campaign => {
            const subTpl = new Webview()
            let subTplURL = campaign && campaign.rv && campaign.rv.template_url

            Webview.getLoadCampaignParams(subTplURL, [campaign], this.unit.id, this.unit.setting)
                .then(loadParams => {
                    console.log('获取到load campaign参数：', loadParams)
                    subTpl.load(loadParams)
                })

            campaign.getTemplate = () => {
                return subTpl
            }
        })

        var VConsole = require('vconsole');
        window.vConsole === undefined && (window.vConsole = new VConsole());

    }

    @report([presetOnlyImpression, presetPvUrls, presetBtPlayFirstShow])
    onlyImpressionTimingReport() {
        console.log('onlyImpression Timing Report')
    }

    @report([presetBtPlayFirstDialogShow])
    dialogShowTimingReport() {
        console.log('dialogShow Timing Report')
    }

    @report([presetBtPlayFirstDialogClick])
    dialogClickTimingReport() {
        console.log('dialogClick Timing Report')
    }

    @report([presetBtPlayFirstDialogCloseManual])
    dialogCloseManualTimingReport() {
        console.log('dialogCloseManual Timing Report')
    }

    @report([presetBtPlayFirstDialogCloseAuto])
    dialogCloseAutoTimingReport() {
        console.log('dialogCloseAuto Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizImpression
    }, {
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingImpression
    },])
    impressionTimingReport() {
        console.log('impression Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingClick
    }, {
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizNoticeUrl
    }, presetBtPlayFirstClick])
    clickTimingReport() {
        console.log('click Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAddRewardToServer
    }])
    addRewardToServerTimingReport() {
        console.log('addRewardToServer Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoStart
    }])
    videoStartTimingReport() {
        console.log('videoStart Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoFirstQuartile
    }])
    videoFirstQuartileTimingReport() {
        console.log('VideoFirstQuartile Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoMidpoint
    }])
    videoMidpointTimingReport() {
        console.log('videoMidpoint Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoThirdQuartile
    }])
    videoThirdQuartileTimingReport() {
        console.log('videoThirdQuartile Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoComplete
    }])
    videoCompleteTimingReport() {
        console.log('videoComplete Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0], rate: 0}
        },
        action: reportBizAdTrackingVideoPlayPercentage
    }])
    videoPercentage0TimingReport() {
        console.log('VideoPercentage0 Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0], rate: 25}
        },
        action: reportBizAdTrackingVideoPlayPercentage
    }])
    videoPercentage25TimingReport() {
        console.log('VideoPercentage25 Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0], rate: 50}
        },
        action: reportBizAdTrackingVideoPlayPercentage
    }])
    videoPercentage50TimingReport() {
        console.log('VideoPercentage50 Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0], rate: 75}
        },
        action: reportBizAdTrackingVideoPlayPercentage
    }])
    videoPercentage75TimingReport() {
        console.log('VideoPercentage75 Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0], rate: 100}
        },
        action: reportBizAdTrackingVideoPlayPercentage
    }])
    videoPercentage100TimingReport() {
        console.log('VideoPercentage100 Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoPause
    }])
    videoPauseTimingReport() {
        console.log('videoPause Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoClose
    }])
    videoCloseTimingReport() {
        console.log('videoClose Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoMute
    }])
    videoMuteTimingReport() {
        console.log('videoMute Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingVideoUnmute
    }])
    videoUnmuteTimingReport() {
        console.log('videoUnmute Timing Report')
    }

    @report([{
        // 动态取值
        value: function () {
            return {currentCampaign: App.initData.campaignList[0]}
        },
        action: reportBizAdTrackingEndcardShow
    }])
    endcardShowTimingReport() {
        console.log('endcardShow Timing Report')
    }

    @report([presetBtPlayFirstClose])
    adCloseTimingReport() {
        console.log('adClose Timing Report')
    }

    reactDevelop1(){
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...App.h5Setting,
            campaign:this.campaignList[0],
            nodeName:"showSuccess",
            adShowTime:this.adShowTime
        })
    }
    reactDevelop2(){
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...App.h5Setting,
            campaign:this.campaignList[0],
            nodeName:"showFailed",
            adShowTime:this.adShowTime,
            error:{
                code:"99999",
                msg:"测试错误信息"
            }
        })
    }
    reactDevelop3(){
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...App.h5Setting,
            campaign:this.campaignList[0],
            nodeName:"playCompleted",
            adShowTime:this.adShowTime
        })
    }
    reactDevelop4(){
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...App.h5Setting,
            campaign:this.campaignList[0],
            nodeName:"endcardShowSuccess",
            adShowTime:this.adShowTime
        })
    }
    reactDevelop5(){
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...App.h5Setting,
            campaign:this.campaignList[0],
            nodeName:"clicked",
            adShowTime:this.adShowTime
        })
    }
    reactDevelop6(){
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...App.h5Setting,
            campaign:this.campaignList[0],
            nodeName:"dismissed",
            adShowTime:this.adShowTime,
            convert:1,
            reward:this.reward
        })
    }
    reactDevelop7(){
        // 调用回调/扣回调方法
        this.platform.callReactDeveloper({
            ...App.initData,
            ...App.h5Setting,
            campaign:this.campaignList[0],
            nodeName:"dismissed",
            adShowTime:this.adShowTime,
            convert:2,
            reward:this.reward
        })
    }

    autoLoad1(){
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign:this.campaignList[0],
            nodeName:"isReady",
        })
    }
    autoLoad2(){
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign:this.campaignList[0],
            nodeName:"showSuccess",
        })
    }
    autoLoad3(){
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign:this.campaignList[0],
            nodeName:"vcnNoReady",
        })
    }
    autoLoad4(){
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign:this.campaignList[0],
            nodeName:"showFailed",
        })
    }
    autoLoad5(){
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign:this.campaignList[0],
            nodeName:"playCompleted",
        })
    }
    autoLoad6(){
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign:this.campaignList[0],
            nodeName:"endcardShowSuccess",
        })
    }
    autoLoad7(){
        // 调用自动load方法
        this.platform.callLoadAds({
            ...App.initData,
            campaign:this.campaignList[0],
            nodeName:"dismissed",
        })
    }
    initOtherPhaseTestCase() {
        let testCaseContainer = document.createElement('div');
        testCaseContainer.id = 'testCaseContainer'
        testCaseContainer.style.cssText += "position: absolute;left: 50%;top: 1vh;overflow: auto;-webkit-overflow-scrolling: touch; padding:1vw;max-height: 90vh;transform: translateX(-50%); background: rgba(0,0,0,.5); border: 2px solid rgba(255,255,255,.8);min-width:10em;min-height:2em;"
        document.body.appendChild(testCaseContainer)

        function addCaseButton(options) {
            options.long = "4"
            new Button(options).appendTo(testCaseContainer)
            testCaseContainer.insertAdjacentHTML("beforeend", '<hr style="min-height: 1vh;">')
        }

        addCaseButton({
            text: '回调/扣回调-type1',
            onClick: () => {
                this.reactDevelop1()
            }
        })
        addCaseButton({
            text: '回调/扣回调-type2',
            onClick: () => {
                this.reactDevelop2()
            }
        })
        addCaseButton({
            text: '回调/扣回调-type3',
            onClick: () => {
                this.reactDevelop3()
            }
        })
        addCaseButton({
            text: '回调/扣回调-type4',
            onClick: () => {
                this.reactDevelop4()
            }
        })
        addCaseButton({
            text: '回调/扣回调-type5',
            onClick: () => {
                this.reactDevelop5()
            }
        })
        addCaseButton({
            text: '回调/扣回调-type6-convert1',
            onClick: () => {
                this.reactDevelop6()
            }
        })
        addCaseButton({
            text: '回调/扣回调-type6-convert2',
            onClick: () => {
                this.reactDevelop7()
            }
        })
        addCaseButton({
            text: '自动load-1',
            onClick: () => {
                this.autoLoad1()
            }
        })
        addCaseButton({
            text: '自动load-2',
            onClick: () => {
                this.autoLoad2()
            }
        })
        addCaseButton({
            text: '自动load-4',
            onClick: () => {
                this.autoLoad4()
            }
        })
        addCaseButton({
            text: '自动load-5',
            onClick: () => {
                this.autoLoad5()
            }
        })
        addCaseButton({
            text: '自动load-6',
            onClick: () => {
                this.autoLoad6()
            }
        })
        addCaseButton({
            text: '自动load-7',
            onClick: () => {
                this.autoLoad7()
            }
        })
        // addCaseButton({
        //     text: 'onlyImpression pv_urls 上报',
        //     onClick: () => {
        //         this.onlyImpressionTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: 'dialogShow 上报',
        //     onClick: () => {
        //         this.dialogShowTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: 'dialogClick 上报',
        //     onClick: () => {
        //         this.dialogClickTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: 'dialogCloseManual 上报',
        //     onClick: () => {
        //         this.dialogCloseManualTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: 'dialogCloseAuto 上报',
        //     onClick: () => {
        //         this.dialogCloseAutoTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: 'impression 上报',
        //     onClick: () => {
        //         this.impressionTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '点击上报',
        //     onClick: () => {
        //         this.clickTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '服务端 reward 回调（上报）',
        //     onClick: () => {
        //         this.addRewardToServerTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '开始播放上报',
        //     onClick: () => {
        //         this.videoStartTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 1/4 上报',
        //     onClick: () => {
        //         this.videoFirstQuartileTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 1/2 上报',
        //     onClick: () => {
        //         this.videoMidpointTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 3/4 上报',
        //     onClick: () => {
        //         this.videoThirdQuartileTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 完成 上报',
        //     onClick: () => {
        //         this.videoCompleteTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 百分比 0 上报',
        //     onClick: () => {
        //         this.videoPercentage0TimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 百分比 25 上报',
        //     onClick: () => {
        //         this.videoPercentage25TimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 百分比 50 上报',
        //     onClick: () => {
        //         this.videoPercentage50TimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 百分比 75 上报',
        //     onClick: () => {
        //         this.videoPercentage75TimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '播放 百分比 100 上报',
        //     onClick: () => {
        //         this.videoPercentage100TimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '视频被用户暂停上报',
        //     onClick: () => {
        //         this.videoPauseTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '视频被用户提前关闭上报',
        //     onClick: () => {
        //         this.videoCloseTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '静音上报',
        //     onClick: () => {
        //         this.videoMuteTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '非静音上报',
        //     onClick: () => {
        //         this.videoUnmuteTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: 'endcard 展示',
        //     onClick: () => {
        //         this.endcardShowTimingReport()
        //     }
        // })
        //
        // addCaseButton({
        //     text: '广告关闭上报',
        //     onClick: () => {
        //         this.adCloseTimingReport()
        //     }
        // })
    }

    bindPageEvent() {
        const offerBanner = document.querySelector('.offer-banner')
        console.log('offerBanner', offerBanner)
        if (offerBanner) {
            console.log('offerBanner addEventListener', offerBanner)
            offerBanner.addEventListener('click', (e) => {
                console.log('offerBanner click', e)
                const nextOffer = this.campaignList[this.campaignList.indexOf(this.currentOffer) + 1] || this.campaignList[0]

                console.log('nextOffer', nextOffer)
                const subTpl = nextOffer.getTemplate()
                console.log('subTpl', subTpl)
                // this.slotOut('slot_1', this.currentOffer.getTemplate())
                this.currentOffer.getTemplate().removeSelf()
                this.slotIn('slot_1', subTpl)
                console.log('subTpl ====')

                offerBanner.innerText = this.currentOffer.title

                this.currentOffer = nextOffer
            }, false)

        }
        const nextOffer = this.campaignList[this.campaignList.indexOf(this.currentOffer) + 1] || this.campaignList[0]
        offerBanner.innerText = nextOffer.title
        // document.documentElement.addEventListener('click', (e) => {
        //     console.log('documentElement click', e)
        // }, false)
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
        this.container.onAppend(event => {
            console.log('onAppend', event)
        })
        this.container.onAppendTo(event => {
            console.log('onAppendTo', event)
        })
        this.container.onBgColorChanged(event => {
            console.log('onBgColorChanged', event)
        })
        this.container.onLoad(event => {
            console.log('onWebviewLoad', event)
        })
        this.container.onClicked(event => {
            console.log('onClicked', event)
        })
    }

    /**
     * 初始化插槽
     */
    initSlots() {
        super.initSlots()
        // this.slotIn('slot_1', this.currentOffer.getTemplate())
        //this.slotInBelow('slot_1', this.currentOffer.getTemplate())
        //this.slotIn('slot_2', this.subTpl2)
        //this.slotInBelow('slot_2', this.subTpl2)
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.currentOffer.getTemplate() && this.currentOffer.getTemplate().destory()
        //this.subTpl2 && this.subTpl2.destory()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        return Promise.all([
            super._isLoadFinish(),
            this.currentOffer.getTemplate().whenCampaignReady()
            //this.subTpl2.whenCampaignReady()
        ])
    }

}